import { StrikeWeightLevel } from '../hammer-weight-level';

// Strike weight curves as listed in David Stanwood's articles
export const strikeWeightData: Record<StrikeWeightLevel, number[]> = {
  [StrikeWeightLevel.Level1]: [
    8.0, 8.0, 8.0, 7.9, 7.9, 7.9, 7.9, 7.8, 7.8, 7.8, 7.8, 7.7, 7.7, 7.7, 7.6,
    7.6, 7.6, 7.6, 7.5, 7.5, 7.5, 7.4, 7.4, 7.4, 7.3, 7.3, 7.3, 7.2, 7.2, 7.1,
    7.1, 7.1, 7.0, 7.0, 6.9, 6.9, 6.8, 6.8, 6.7, 6.7, 6.6, 6.6, 6.6, 6.5, 6.4,
    6.4, 6.3, 6.3, 6.2, 6.2, 6.1, 6.1, 6.0, 6.0, 5.9, 5.8, 5.8, 5.7, 5.7, 5.6,
    5.5, 5.5, 5.4, 5.3, 5.3, 5.2, 5.1, 5.1, 5.0, 4.9, 4.8, 4.8, 4.7, 4.6, 4.5,
    4.5, 4.4, 4.3, 4.2, 4.1, 4.1, 4.0, 3.9, 3.8, 3.7, 3.7, 3.6, 3.5,
  ],
  [StrikeWeightLevel.Level2]: [
    8.6, 8.5, 8.5, 8.5, 8.5, 8.4, 8.4, 8.4, 8.4, 8.3, 8.3, 8.3, 8.2, 8.2, 8.2,
    8.2, 8.1, 8.1, 8.1, 8.0, 8.0, 8.0, 7.9, 7.9, 7.8, 7.8, 7.8, 7.7, 7.7, 7.6,
    7.6, 7.6, 7.5, 7.5, 7.4, 7.4, 7.3, 7.3, 7.2, 7.2, 7.1, 7.1, 7.0, 7.0, 6.9,
    6.9, 6.8, 6.8, 6.7, 6.6, 6.6, 6.5, 6.5, 6.4, 6.3, 6.3, 6.2, 6.1, 6.1, 6.0,
    5.9, 5.9, 5.8, 5.7, 5.6, 5.6, 5.5, 5.4, 5.3, 5.3, 5.2, 5.1, 5.0, 5.0, 4.9,
    4.8, 4.7, 4.6, 4.5, 4.5, 4.4, 4.3, 4.2, 4.1, 4.0, 3.9, 3.9, 3.8,
  ],
  [StrikeWeightLevel.Level3]: [
    9.1, 9.1, 9.1, 9.1, 9.0, 9.0, 9.0, 8.9, 8.9, 8.9, 8.8, 8.8, 8.8, 8.7, 8.7,
    8.7, 8.6, 8.6, 8.6, 8.5, 8.5, 8.5, 8.4, 8.4, 8.4, 8.3, 8.3, 8.2, 8.2, 8.1,
    8.1, 8.1, 8.0, 8.0, 7.9, 7.9, 7.8, 7.8, 7.7, 7.7, 7.6, 7.6, 7.5, 7.4, 7.4,
    7.3, 7.3, 7.2, 7.2, 7.1, 7.0, 7.0, 6.9, 6.8, 6.8, 6.7, 6.6, 6.6, 6.5, 6.4,
    6.3, 6.3, 6.2, 6.1, 6.0, 5.9, 5.9, 5.8, 5.7, 5.6, 5.5, 5.5, 5.4, 5.3, 5.2,
    5.1, 5.0, 4.9, 4.9, 4.8, 4.7, 4.6, 4.5, 4.4, 4.3, 4.2, 4.1, 4.0,
  ],
  [StrikeWeightLevel.Level4]: [
    9.7, 9.7, 9.7, 9.6, 9.6, 9.6, 9.5, 9.5, 9.5, 9.4, 9.4, 9.4, 9.3, 9.3, 9.2,
    9.2, 9.2, 9.1, 9.1, 9.1, 9.0, 9.0, 8.9, 8.9, 8.9, 8.8, 8.8, 8.7, 8.7, 8.6,
    8.6, 8.6, 8.5, 8.5, 8.4, 8.4, 8.3, 8.3, 8.2, 8.2, 8.1, 8.0, 8.0, 7.9, 7.9,
    7.8, 7.7, 7.7, 7.6, 7.5, 7.5, 7.4, 7.3, 7.3, 7.2, 7.1, 7.0, 7.0, 6.9, 6.8,
    6.7, 6.7, 6.6, 6.5, 6.4, 6.3, 6.2, 6.2, 6.1, 6.0, 5.9, 5.8, 5.7, 5.6, 5.5,
    5.4, 5.4, 5.3, 5.2, 5.1, 5.0, 4.9, 4.8, 4.7, 4.6, 4.5, 4.4, 4.3,
  ],
  [StrikeWeightLevel.Level5]: [
    10.3, 10.3, 10.2, 10.2, 10.2, 10.1, 10.1, 10.0, 10.0, 10.0, 9.9, 9.9, 9.9,
    9.8, 9.8, 9.7, 9.7, 9.7, 9.6, 9.6, 9.5, 9.5, 9.5, 9.4, 9.4, 9.3, 9.3, 9.2,
    9.2, 9.2, 9.1, 9.1, 9.0, 9.0, 8.9, 8.9, 8.8, 8.8, 8.7, 8.6, 8.6, 8.5, 8.5,
    8.4, 8.3, 8.3, 8.2, 8.1, 8.1, 8.0, 7.9, 7.9, 7.8, 7.7, 7.6, 7.5, 7.5, 7.4,
    7.3, 7.2, 7.1, 7.0, 7.0, 6.9, 6.8, 6.7, 6.6, 6.5, 6.4, 6.3, 6.2, 6.2, 6.1,
    6.0, 5.9, 5.8, 5.7, 5.6, 5.5, 5.4, 5.3, 5.2, 5.1, 5.0, 4.9, 4.8, 4.7, 4.6,
  ],
  [StrikeWeightLevel.Level6]: [
    10.8, 10.8, 10.8, 10.7, 10.7, 10.6, 10.6, 10.6, 10.5, 10.5, 10.4, 10.4,
    10.4, 10.3, 10.3, 10.2, 10.2, 10.2, 10.1, 10.1, 10.0, 10.0, 10.0, 9.9, 9.9,
    9.8, 9.8, 9.7, 9.7, 9.6, 9.6, 9.5, 9.5, 9.4, 9.4, 9.3, 9.3, 9.2, 9.2, 9.1,
    9.0, 9.0, 8.9, 8.8, 8.8, 8.7, 8.6, 8.6, 8.5, 8.4, 8.4, 8.3, 8.2, 8.1, 8.1,
    8.0, 7.9, 7.8, 7.7, 7.6, 7.5, 7.5, 7.4, 7.3, 7.2, 7.1, 7.0, 6.9, 6.8, 6.7,
    6.6, 6.5, 6.4, 6.3, 6.2, 6.1, 6.0, 5.9, 5.8, 5.7, 5.6, 5.5, 5.4, 5.3, 5.2,
    5.1, 5.0, 4.9,
  ],
  [StrikeWeightLevel.Level7]: [
    11.3, 11.3, 11.3, 11.2, 11.2, 11.2, 11.1, 11.1, 11.0, 11.0, 11.0, 10.9,
    10.9, 10.8, 10.8, 10.8, 10.7, 10.7, 10.6, 10.6, 10.5, 10.5, 10.5, 10.4,
    10.4, 10.3, 10.3, 10.2, 10.2, 10.1, 10.1, 10.0, 10.0, 9.9, 9.9, 9.8, 9.7,
    9.7, 9.6, 9.6, 9.5, 9.4, 9.4, 9.3, 9.2, 9.2, 9.1, 9.0, 8.9, 8.9, 8.8, 8.7,
    8.6, 8.6, 8.5, 8.4, 8.3, 8.2, 8.1, 8.1, 8.0, 7.9, 7.8, 7.7, 7.6, 7.5, 7.4,
    7.3, 7.2, 7.1, 7.0, 6.9, 6.8, 6.7, 6.6, 6.5, 6.4, 6.3, 6.2, 6.1, 6.0, 5.9,
    5.7, 5.6, 5.5, 5.4, 5.3, 5.2,
  ],
  [StrikeWeightLevel.Level8]: [
    11.9, 11.8, 11.8, 11.8, 11.7, 11.7, 11.6, 11.6, 11.6, 11.5, 11.5, 11.4,
    11.4, 11.4, 11.3, 11.3, 11.2, 11.2, 11.1, 11.1, 11.0, 11.0, 11.0, 10.9,
    10.9, 10.8, 10.8, 10.7, 10.7, 10.6, 10.5, 10.5, 10.4, 10.4, 10.3, 10.3,
    10.2, 10.1, 10.1, 10.0, 10.0, 9.9, 9.8, 9.7, 9.7, 9.6, 9.5, 9.5, 9.4, 9.3,
    9.2, 9.2, 9.1, 9.0, 8.9, 8.8, 8.7, 8.6, 8.6, 8.5, 8.4, 8.3, 8.2, 8.1, 8.0,
    7.9, 7.8, 7.7, 7.6, 7.5, 7.4, 7.3, 7.2, 7.1, 7.0, 6.9, 6.7, 6.6, 6.5, 6.4,
    6.3, 6.2, 6.1, 6.0, 5.8, 5.7, 5.6, 5.5,
  ],
  [StrikeWeightLevel.Level9]: [
    12.4, 12.4, 12.3, 12.3, 12.2, 12.2, 12.2, 12.1, 12.1, 12.0, 12.0, 12.0,
    11.9, 11.9, 11.8, 11.8, 11.7, 11.7, 11.6, 11.6, 11.5, 11.5, 11.5, 11.4,
    11.4, 11.3, 11.2, 11.2, 11.1, 11.1, 11.0, 11.0, 10.9, 10.9, 10.8, 10.7,
    10.7, 10.6, 10.5, 10.5, 10.4, 10.3, 10.3, 10.2, 10.1, 10.1, 10.0, 9.9, 9.8,
    9.7, 9.7, 9.6, 9.5, 9.4, 9.3, 9.2, 9.2, 9.1, 9.0, 8.9, 8.8, 8.7, 8.6, 8.5,
    8.4, 8.3, 8.2, 8.1, 8.0, 7.9, 7.8, 7.7, 7.5, 7.4, 7.3, 7.2, 7.1, 7.0, 6.9,
    6.7, 6.6, 6.5, 6.4, 6.3, 6.2, 6.0, 5.9, 5.8,
  ],
  [StrikeWeightLevel.Level10]: [
    13.0, 13.0, 12.9, 12.9, 12.8, 12.8, 12.7, 12.7, 12.7, 12.6, 12.6, 12.5,
    12.5, 12.4, 12.4, 12.3, 12.3, 12.2, 12.2, 12.2, 12.1, 12.0, 12.0, 11.9,
    11.9, 11.8, 11.8, 11.7, 11.7, 11.6, 11.6, 11.5, 11.4, 11.4, 11.3, 11.2,
    11.2, 11.1, 11.0, 11.0, 10.9, 10.8, 10.7, 10.7, 10.6, 10.5, 10.4, 10.4,
    10.3, 10.2, 10.1, 10.0, 9.9, 9.9, 9.8, 9.7, 9.6, 9.5, 9.4, 9.3, 9.2, 9.1,
    9.0, 8.9, 8.8, 8.7, 8.6, 8.5, 8.3, 8.2, 8.1, 8.0, 7.9, 7.8, 7.7, 7.5, 7.4,
    7.3, 7.2, 7.1, 6.9, 6.8, 6.7, 6.6, 6.4, 6.3, 6.2, 6.1,
  ],
  [StrikeWeightLevel.Level11]: [
    13.6, 13.6, 13.5, 13.5, 13.4, 13.4, 13.3, 13.3, 13.2, 13.2, 13.1, 13.1,
    13.1, 13.0, 13.0, 12.9, 12.9, 12.8, 12.8, 12.7, 12.7, 12.6, 12.5, 12.5,
    12.4, 12.4, 12.3, 12.3, 12.2, 12.1, 12.1, 12.0, 11.9, 11.9, 11.8, 11.7,
    11.7, 11.6, 11.5, 11.5, 11.4, 11.3, 11.2, 11.1, 11.1, 11.0, 10.9, 10.8,
    10.7, 10.6, 10.6, 10.5, 10.4, 10.3, 10.2, 10.1, 10.0, 9.9, 9.8, 9.7, 9.6,
    9.5, 9.4, 9.3, 9.2, 9.0, 8.9, 8.8, 8.7, 8.6, 8.5, 8.4, 8.2, 8.1, 8.0, 7.9,
    7.7, 7.6, 7.5, 7.4, 7.2, 7.1, 7.0, 6.9, 6.7, 6.6, 6.5, 6.3,
  ],
  [StrikeWeightLevel.Level12]: [
    14.2, 14.2, 14.1, 14.1, 14.0, 14.0, 13.9, 13.9, 13.8, 13.8, 13.7, 13.7,
    13.6, 13.6, 13.5, 13.5, 13.4, 13.4, 13.3, 13.3, 13.2, 13.1, 13.1, 13.0,
    13.0, 12.9, 12.9, 12.8, 12.7, 12.7, 12.6, 12.5, 12.5, 12.4, 12.3, 12.2,
    12.2, 12.1, 12.0, 11.9, 11.9, 11.8, 11.7, 11.6, 11.5, 11.5, 11.4, 11.3,
    11.2, 11.1, 11.1, 10.9, 10.8, 10.7, 10.6, 10.5, 10.4, 10.3, 10.2, 10.1,
    10.0, 9.9, 9.8, 9.7, 9.5, 9.4, 9.3, 9.2, 9.1, 8.9, 8.8, 8.7, 8.6, 8.5, 8.3,
    8.2, 8.1, 7.9, 7.8, 7.7, 7.6, 7.4, 7.3, 7.2, 7.0, 6.9, 6.8, 6.6,
  ],
  [StrikeWeightLevel.Level13]: [
    14.8, 14.8, 14.7, 14.7, 14.6, 14.6, 14.5, 14.5, 14.4, 14.4, 14.3, 14.3,
    14.2, 14.1, 14.1, 14.0, 14.0, 13.9, 13.9, 13.8, 13.8, 13.7, 13.6, 13.6,
    13.5, 13.5, 13.4, 13.3, 13.3, 13.2, 13.1, 13.0, 13.0, 12.9, 12.8, 12.8,
    12.7, 12.6, 12.5, 12.4, 12.4, 12.3, 12.2, 12.1, 12.0, 11.9, 11.8, 11.7,
    11.6, 11.5, 11.5, 11.3, 11.2, 11.1, 11.0, 10.9, 10.8, 10.7, 10.6, 10.5,
    10.4, 10.3, 10.2, 10.0, 9.9, 9.8, 9.7, 9.6, 9.4, 9.3, 9.2, 9.0, 8.9, 8.8,
    8.7, 8.5, 8.4, 8.3, 8.1, 8.0, 7.9, 7.7, 7.6, 7.4, 7.3, 7.2, 7.0, 6.9,
  ],
};

// Keypoints to generate interpolated strike weight curve, with little adjustments for SW#11 and SW#3
export const strikeWeightKeyPointsByLevel: Record<
  StrikeWeightLevel,
  Map<number, number>
> = {
  [StrikeWeightLevel.Level1]: new Map([
    [1, 8],
    [22, 7.4],
    [44, 6.5],
    [66, 5.2],
    [88, 3.5],
  ]),
  [StrikeWeightLevel.Level2]: new Map([
    [1, 8.6],
    [22, 8],
    [44, 7],
    [66, 5.6],
    [88, 3.8],
  ]),
  [StrikeWeightLevel.Level3]: new Map([
    [1, 9.1],
    [22, 8.5],
    [44, 7.4],
    [66, 5.9],
    [88, 4.05],
  ]),
  [StrikeWeightLevel.Level4]: new Map([
    [1, 9.7],
    [22, 9],
    [44, 7.9],
    [66, 6.3],
    [88, 4.3],
  ]),
  [StrikeWeightLevel.Level5]: new Map([
    [1, 10.3],
    [22, 9.5],
    [44, 8.4],
    [66, 6.7],
    [88, 4.6],
  ]),
  [StrikeWeightLevel.Level6]: new Map([
    [1, 10.8],
    [22, 10],
    [44, 8.8],
    [66, 7.1],
    [88, 4.9],
  ]),
  [StrikeWeightLevel.Level7]: new Map([
    [1, 11.3],
    [22, 10.5],
    [44, 9.3],
    [66, 7.5],
    [88, 5.2],
  ]),
  [StrikeWeightLevel.Level8]: new Map([
    [1, 11.9],
    [22, 11],
    [44, 9.7],
    [66, 7.9],
    [88, 5.5],
  ]),
  [StrikeWeightLevel.Level9]: new Map([
    [1, 12.4],
    [22, 11.5],
    [44, 10.2],
    [66, 8.3],
    [88, 5.8],
  ]),
  [StrikeWeightLevel.Level10]: new Map([
    [1, 13],
    [22, 12],
    [44, 10.7],
    [66, 8.7],
    [88, 6.1],
  ]),
  [StrikeWeightLevel.Level11]: new Map([
    [1, 13.6],
    [22, 12.6],
    [44, 11.1],
    [66, 9],
    [88, 6.35],
  ]),
  [StrikeWeightLevel.Level12]: new Map([
    [1, 14.2],
    [22, 13.1],
    [44, 11.6],
    [66, 9.4],
    [88, 6.6],
  ]),
  [StrikeWeightLevel.Level13]: new Map([
    [1, 14.8],
    [22, 13.7],
    [44, 12.1],
    [66, 9.8],
    [88, 6.9],
  ]),
};
